<div class="relative flex flex-row h-full w-full" aria-labelledby="lop-title" role="dialog"
    aria-modal="true" aria-busy="true">

    <div class="absolute inset-0 z-10 overflow-hidden green-noise-bg flex items-center justify-center">

        <div
            class="lc-surface relative w-[90%] sm:w-1/2 max-w-[520px] max-h-[90%] flex flex-col items-center justify-center overflow-hidden p-6 gap-y-2">

            <!-- ambient drifting glow (dark mode) -->
            <div aria-hidden="true" class="lc-glow"></div>

            <!-- equalizer — "turn up the volume" -->
            <div class="lc-eq" aria-hidden="true">
                @for (bar of bars; track $index) {
                <span class="lc-bar"></span>
                }
            </div>

            <div class="text-center max-w-[460px]">
                <h3 id="lop-title" class="lc-title">Turning Up the Volume</h3>
                <p class="lc-sub">Publishing <b>{{ briefTitle() }}</b> to the SHOUT creator network…</p>
            </div>

            <!-- publishing stages -->
            <ul class="lc-steps" aria-live="polite">
                @for (step of steps; track step.label; let i = $index) {
                <li class="lc-step" [class.active]="i === activeStep()" [class.done]="i < activeStep()">
                    <span class="lc-ic" aria-hidden="true">
                        <span class="ring"></span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lc-check">
                            <path d="M20 6 9 17l-5-5" />
                        </svg>
                    </span>
                    <span class="lc-lbl">{{ step.label }}</span>
                </li>
                }
            </ul>

        </div>

    </div>
</div>
